import React, { useState, useEffect, useRef } from 'react';
import { trim } from 'lodash';
import { Input } from '../component/ui/input';
import { use } from 'marked';

const FormField = (props) => {
  const { 
    input, 
    meta, 
    onDropDownChange = () => {}, 
    actionType, 
    info="", 
    ...rest 
  } = props;

  // Set the initial value based on actionType and value
  const initialValue = (actionType === "View" || actionType==="Edit") && info!=="" ? info : input.value || '';
  const [text, setText] = useState(initialValue);
  const textareaRef = useRef(null);


  // useEffect(()=>{
  //   console.log("From renderfield",text,info)
  // })

  const handleChange = (event) => {
    setText(event.target.value);
    input.onChange(event); // Update the form value
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }, [text]);

  const dropDownChange = (event) => {
    const { input: { name } } = props;
    if (onDropDownChange) {
      onDropDownChange({ name, value: event.target.value });
    }
  };

  return (
    <>
      {input.type === 'dropdown' ? (
       <div>
       <select {...rest} {...input} {...(onDropDownChange ? { onChange: dropDownChange } : {})}>
         {rest.placeholder && <option value="">{rest.placeholder}</option>}
         {rest.data?.map((value, key) => (
           <option key={`reduxDropdown${key}`} value={value}>{value}</option>
         ))}
       </select>
       {meta.touched && meta.error && (
         <p className="text-red-500 text-sm text-left">&nbsp;{meta.error}</p>
       )}
     </div>
      ) : null}

      {(input.type === 'text' ||
      input.type === 'email' ||
      input.type === 'number' ||
      input.type === 'password' ||
      input.type === 'checkbox') ? (
        <Input {...rest} {...input} value={text} onChange={handleChange} type={input.type} />
      ) : input.type === 'textarea' ? (
        <textarea
          {...rest}
          {...input}
          ref={textareaRef}
          value={text}
          onChange={handleChange}
         
          style={{ overflow: 'hidden', transition: 'height 0.2s ease' }}
        />
      ) : null}

      {meta.touched && meta.error && (
        <p className="text-red-500 text-sm text-left">&nbsp;{meta.error}</p>
      )}
    </>
  );
};

// RenderField and validators
export const renderField = (props) => <FormField {...props} />;

export const composeValidators =
  (...validators) =>
  (value, allValues) =>
    validators.reduce((error, validator) => error || validator(value, allValues), undefined);

export const dropdownRequired = (value) => value ? undefined : 'Please select an option';
export const required = (value) => (trim(value) ? undefined : 'Required');
export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined;
export const password = (value) =>
  value && !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/i.test(value)
    ? 'Password must be 8+ characters, with 1 uppercase, 1 lowercase, 1 number, and 1 special character.'
    : undefined;
export const passwordsMustMatch = (value, allValues) =>
  value !== allValues.password ? 'Passwords do not match' : undefined;

export const preventNonNumericAndRestrictLength = (event, maxLength = Infinity) => {
  const { key, target: inputField } = event;
  const { value } = inputField;

  // Allowed control keys (for navigation and editing)
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

  // Check if key is numeric
  const isNumericKey = /^[0-9]$/.test(key);

  // Prevent non-numeric and non-control keys
  if (!isNumericKey && !allowedKeys.includes(key)) {
    event.preventDefault();
    return;
  }

  // Restrict total length
  if (value.length >= maxLength && isNumericKey) {
    event.preventDefault();
  }
};


export const preventNonNumericAndRestrictDecimal = (event, decimalPlaces = 2) => {
  const { key, target: inputField ,ctrlKey, metaKey} = event;
  const { value } = inputField;

  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", ".", "Control",];

  const isDigitKey = /^[0-9]$/.test(key);

  const isDecimalKey = key === ".";


    // Allow Ctrl + C (copy) and Ctrl + X (cut)
    if ((ctrlKey || metaKey) && (key === "c" || key === "x" || key==="a" || key==="v")) {
      return;
    }

  // Prevent non-digit, non-decimal, and non-control keys
  if (!isDigitKey && !isDecimalKey && !allowedKeys.includes(key)) {
    event.preventDefault();
    return;
  }

  // Allow only one decimal point
  if (isDecimalKey && value.includes(".")) {
    event.preventDefault();
    return;
  }

  // Restrict digits after the decimal point
  if (value.includes(".") && isDigitKey) {
    const decimalPart = value.split(".")[1] || "";
    if (decimalPart.length >= decimalPlaces) {
      event.preventDefault();
    }
  }
};


export const pinCodeRestriction = (event, maxLength = Infinity) => {
  const { key, target: inputField } = event;
  const { value } = inputField;

  // Allowable keys
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];

  const isNumericKey = key >= "0" && key <= "9";
  const isAlphabetKey = /^[a-zA-Z]$/.test(key); // Only Capital letter included

  // Prevent keys that are neither numeric, alphabetic, nor control keys
  if (!isNumericKey && !isAlphabetKey && !allowedKeys.includes(key)) {
    event.preventDefault();
    return;
  }

  // Restrict total length
  if (value.length >= maxLength && (isNumericKey || isAlphabetKey)) {
    event.preventDefault();
  }
};

export const validatePassword = (value) => {
    const validation = {
      length: value && value.length >= 8,
      uppercase: value && /[A-Z]/.test(value),
      lowercase: value && /[a-z]/.test(value),
      digit: value && /\d/.test(value),
      special: value && /[!@#$%^&*(),.?":{}|<>]/.test(value),
    };

    if (!validation.length) return 'Password must be at least 8 characters.';
    if (!validation.uppercase) return 'Password must contain at least one uppercase letter.';
    if (!validation.lowercase) return 'Password must contain at least one lowercase letter.';
    if (!validation.digit) return 'Password must contain at least one number.';
    if (!validation.special) return 'Password must contain at least one special character.';

    return undefined;
};

export const renderTabField = ({ input, meta, ...rest }) => (
  <div>
    <Input {...rest} {...input} value={input.value} onChange={input.onChange} />
    {meta.touched && meta.error && (
      <p className="text-red-500 text-sm text-left">&nbsp;{meta.error}</p>
    )}
  </div>
);

export const characterLimit = ( maxLimit) => (value) => {
  if (value && String(value).length >maxLimit ) {
    return `Maximum character limit reached. Please keep it under ${maxLimit}.`;
  } 
  return undefined;
};

  
  // export const isNumericInput = (event) => {
  //   const key = event.key;
  //   return (
  //     (key >= "0" && key <= "9") || // Allow number keys
  //     key === "Backspace" || // Allow Backspace
  //     key === "Delete" || // Allow Delete
  //     key === "ArrowLeft" || // Allow left arrow key
  //     key === "ArrowRight" || // Allow right arrow key
  //     key === "Tab" // Allow tab
  //   );
  // };
  
  // export const preventNonNumeric = (event) => {
  //   if (!isNumericInput(event)) {
  //     event.preventDefault();
  //   }
  // };
  

// export const url = (value) =>
//   value &&
//   !/^(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*[-A-Za-z0-9+&@#/%=~_|]$/.test(value)
//     ? 'Invalid URL'
//     : undefined;

//     export const openApiUrl = (value) =>
//       value &&
//       !/https:\/\/.+\.json/.test(value)
//         ? 'Invalid OpenAPI URL'
//         : undefined;
    